import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

type Tip = { text: string; html?: string; left: number; top: number; below: boolean };

export function AppTooltip() {
  const [tip, setTip] = useState<Tip>();
  useEffect(() => {
    let target: HTMLElement | null = null;
    let previousDescription: string | null = null;
    const hide = () => {
      if (target) {
        if (previousDescription) target.setAttribute("aria-describedby", previousDescription);
        else target.removeAttribute("aria-describedby");
      }
      target = null;
      setTip(undefined);
    };
    const show = (event: Event) => {
      const element = event.target instanceof Element ? event.target.closest<HTMLElement>("[data-tooltip]") : null;
      if (!element || !element.dataset.tooltip) { hide(); return; }
      if (element === target) return;
      hide();
      target = element;
      previousDescription = element.getAttribute("aria-describedby");
      element.setAttribute("aria-describedby", [previousDescription, "travel-tooltip"].filter(Boolean).join(" "));
      const rect = element.getBoundingClientRect();
      const halfWidth = Math.min(320, window.innerWidth - 24) / 2;
      // La scheda ricca è alta circa 320 px: sopra se c'è posto, altrimenti dal lato con più spazio.
      const needed = element.dataset.tooltipHtml ? 330 : 100;
      const spaceAbove = rect.top - 10, spaceBelow = window.innerHeight - rect.bottom - 10;
      const below = spaceAbove < needed && spaceBelow > spaceAbove;
      setTip({ text: element.dataset.tooltip, html: element.dataset.tooltipHtml, left: Math.max(halfWidth + 12, Math.min(window.innerWidth - halfWidth - 12, rect.left + rect.width / 2)), top: below ? rect.bottom + 10 : rect.top - 10, below });
    };
    const leave = (event: Event) => {
      const related = (event as MouseEvent).relatedTarget;
      if (!(related instanceof Node) || !target?.contains(related)) hide();
    };
    const escape = (event: KeyboardEvent) => { if (event.key === "Escape") hide(); };
    document.addEventListener("pointerover", show);
    document.addEventListener("pointerout", leave);
    document.addEventListener("focusin", show);
    document.addEventListener("focusout", leave);
    document.addEventListener("pointerdown", hide);
    document.addEventListener("keydown", escape);
    document.addEventListener("scroll", hide, true);
    window.addEventListener("resize", hide);
    return () => {
      hide();
      document.removeEventListener("pointerover", show);
      document.removeEventListener("pointerout", leave);
      document.removeEventListener("focusin", show);
      document.removeEventListener("focusout", leave);
      document.removeEventListener("pointerdown", hide);
      document.removeEventListener("keydown", escape);
      document.removeEventListener("scroll", hide, true);
      window.removeEventListener("resize", hide);
    };
  }, []);
  // L'HTML ricco è costruito solo dal codice dell'app, con i testi già neutralizzati (escapeLabel).
  return tip ? createPortal(tip.html
    ? <div id="travel-tooltip" role="tooltip" aria-label={tip.text} className={`app-tooltip is-rich ${tip.below ? "is-below" : ""}`} style={{ left: tip.left, top: tip.top }} dangerouslySetInnerHTML={{ __html: tip.html }} />
    : <div id="travel-tooltip" role="tooltip" className={`app-tooltip ${tip.below ? "is-below" : ""}`} style={{ left: tip.left, top: tip.top }}>{tip.text}</div>, document.body) : null;
}
